import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { biochemistryData } from '../../data/departmentalData/biochemistry';

const Biochemistry = () => {
  return <TemplatePage data={biochemistryData} />;
};

export default Biochemistry;
